export const limitsTranslationKeys = {
  STRAIGHTUP: 'STRAIGHT_UP',
  SPLIT: 'SPLIT',
  STREET: 'STREET',
  CORNER: 'CORNER',
  SIXLINE: 'LINE',
  LINE: 'LINE',
  COLUMN: 'COLUMN',
  DOZEN: 'DOZEN',
  'RED/BLACK': 'RED_BLACK',
  BLACK: 'BLACK',
  RED: 'RED',
  'EVEN/ODD': 'EVEN_ODD',
  EVEN: 'EVEN',
  ODD: 'ODD',
  ROUND_ID: 'ROUND_ID',
  '1_18/19_36': '1_18/19_36',
};
